
//
// Polyfill Promise for IE
//
window.Promise || (function() {
    var scr = document.createElement('script')
    scr.src = 'https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.auto.min.js'
    document.head.appendChild(scr)
})()
//
// End Polyfill
//
    

      
//
// Quick Search Fix
//
      
var bold_BoostPFSInstantSearchCallback = BoostPFSInstantSearchCallback;
var BoostPFSInstantSearchCallback = function(response) {
  var promises = []
  for (var n = 0; n < response.products.length; n++) {
    if (response.products[n].product_type === 'DISCOUNT_HIDDEN_PRODUCT' || response.products[n].tags.indexOf('DISCOUNT_HIDDEN_PRODUCT') != -1 || response.products[n].product_type === "OPTIONS_HIDDEN_PRODUCT" || response.products[n].product_type === 'MOTIVATOR_HIDDEN_PRODUCT' || response.products[n].tags.indexOf('MOTIVATOR_HIDDEN_PRODUCT') != -1) {
      response.products.splice(n, 1);
      n--;
      continue;
    }
    promises.push(new Promise(function(resolve, reject) {
      BOLD.helpers.getProduct(response.products[n].handle, function(n, prod) {
        if (prod.hidden) {
          response.products[n].bold_ignore = true;
          return resolve()
        }
        response.products[n].price_min = prod.price_min/100;
        response.products[n].price_max = prod.price_max/100;
        return resolve()
      }.bind(this, n), {}, function(i) {
        response.products[i].bold_ignore = true
        return resolve()
      }.bind(this, n));
    }))
  }
  Promise.all(promises).then(function() {
    var final_products = []
    var prod
    for (var i in response.products) {
      prod = response.products[i]
      if (typeof prod === 'object' && !prod.bold_ignore) {
        final_products.push(prod)
      }
    }
    response.products = final_products
    bold_BoostPFSInstantSearchCallback(response);
  })
}
      
//
// End Quick Search Fix
//
      

    
//
// Bold Helpers getProduct (For Quick Search Fix)
//
 
var BOLD=window.BOLD||{};BOLD.helpers=BOLD.helpers||{},BOLD.helpers.getProduct=function(e,t,o,r){var n,s="/products/"+e;(o=o||{}).raw?s+=".js":s+="?view="+(o.view||"json"),(n=new XMLHttpRequest).onreadystatechange=function(){if(4==n.readyState&&200==n.status)try{var s=n.responseText;"string"==typeof s&&(s=JSON.parse(s)),"function"==typeof t?t(s):"object"==typeof Shopify&&"function"==typeof Shopify.onProduct&&Shopify.onProduct(s)}catch(r){if(o.raw)return!1;BOLD.helpers.getProduct(e,t,{raw:!0})}else 404==n.status&&r()},n.open("GET",s,!0),n.send()};
     
//
// End Bold Helpers getProduct
//
